package fr.manyverse.app.domain.model

import kotlin.time.Instant

/**
 * Represents a cached signed URL with its expiration time.
 * Used to cache Supabase Storage signed URLs to reduce API calls.
 *
 * [version] identifie le *contenu* signé (typiquement l'`updated_at` de la ligne qui porte
 * l'image). Les chemins de stockage étant déterministes (`{userId}/{characterId}.webp`),
 * remplacer un avatar ne change pas le chemin : sans cette version, un appareil qui n'a pas
 * fait l'upload lui-même continuerait de servir l'URL signée mise en cache — donc l'ancienne
 * image — pendant toute la durée de vie de l'entrée.
 */
data class SignedUrlCacheEntry(
    val signedUrl: String,
    val expiresAt: Instant,
    val version: String? = null
)
